import {
  Redirect as TheIcon
} from 'components/icons';

// OR
// import React from 'react';
// import { Icon } from "semantic-ui-react";

// function TheIcon (props) {
//   return <Icon name="info" {...props} />;
// }

export const meta = {
  id: 'CMSRedirects',
  title: 'CMS Redirects',
  category: 'CMS',
  // exposes: [
    
  // ],
  unique: true,
  icon: TheIcon,
  version: '1.0.0',
  description: `Manage the redirects for the pages`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    // width: 630,
    // height: 380
  }
};
